import React from "react";

/**
 * Global error boundary. A single component error (e.g. a missing import) must
 * NEVER black out the whole site — previously such an error crashed the entire
 * React tree, leaving a blank page that only recovered on a hard reload.
 * This catches render errors and shows a recoverable fallback instead.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary-fallback"
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "#0a0a0a",
            color: "#e5e5e5",
            fontFamily: "Outfit, Arial, sans-serif",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: "20px", fontWeight: 800, color: "#FFCC51", marginBottom: "12px" }}>
            Es ist ein Fehler aufgetreten
          </div>
          <p style={{ fontSize: "14px", color: "#a1a1aa", maxWidth: "440px", lineHeight: 1.6 }}>
            Diese Seite konnte nicht geladen werden. Bitte lade die Seite neu oder
            kehre zur Startseite zurück.
          </p>
          <div style={{ display: "flex", gap: "12px", marginTop: "24px" }}>
            <button
              data-testid="error-reload-btn"
              onClick={() => window.location.reload()}
              style={{
                background: "#FFCC51", color: "#0a0a0a", border: "none",
                borderRadius: "9999px", padding: "10px 22px", fontWeight: 700, cursor: "pointer",
              }}
            >
              Neu laden
            </button>
            <button
              data-testid="error-home-btn"
              onClick={() => { window.location.href = "/"; }}
              style={{
                background: "transparent", color: "#e5e5e5", border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "9999px", padding: "10px 22px", fontWeight: 600, cursor: "pointer",
              }}
            >
              Zur Startseite
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
